module.exports = __webpack_public_path__ + "static/img/4.ceaec86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1/4.png
// module id = pGVZ
// module chunks = 1